import { render, staticRenderFns } from "./CombinationsEditPopup.vue?vue&type=template&id=4d643599&scoped=true"
import script from "./CombinationsEditPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsEditPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsEditPopup.vue?vue&type=style&index=0&id=4d643599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d643599",
  null
  
)

export default component.exports